import script from "./PageViewBarChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageViewBarChart.vue?vue&type=script&lang=ts&setup=true"

import "./PageViewBarChart.vue?vue&type=style&index=0&id=f5ce8726&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5ce8726"]])

export default __exports__